import metadata from './data/metadata.json';
import type { IssMunicipalDataVersion } from './types.js';

export const ISS_MUNICIPAL_DATA_VERSION = metadata as IssMunicipalDataVersion;
